import {HttpRequest,HttpMethod} from "./http";

class MemberProvider extends HttpRequest {

	// CRUD Member
	MemberCreate(params){
		return this.request(HttpMethod.Post,`/api/v2/member`,params );
	}

	MemberList(params){
		return this.request(HttpMethod.Get,`/api/v2/member`,params );
	}

	MemberGet(id){
		return this.request(HttpMethod.Get,`/api/v2/member/${id}`);
	}

	MemberUpdate(id,params){
		return this.request(HttpMethod.Put,`/api/v2/member/${id}`,params );
	}

	MemberDelete(id){
		return this.request(HttpMethod.Delete,`/api/v2/member/${id}`);
	}

	// Member Coupons
	MemberGetCoupons(id, params){
		return this.request(HttpMethod.Get,`/api/v2/member/${id}/coupons`,params );
	}

	// Member Coupon Management
	MemberCouponList(params){
		return this.request(HttpMethod.Get,`/api/v2/member-coupons`,params );
	}

	MemberCouponAssign(params){
		return this.request(HttpMethod.Post,`/api/v2/member-coupons/assign`,params );
	}

	MemberCouponRemove(id){
		return this.request(HttpMethod.Delete,`/api/v2/member-coupons/${id}`);
	}
}

export default MemberProvider